module.exports = __webpack_public_path__ + "static/media/sortEmpty.ecad4362.svg";